import logoMarkUrl from "@inventory/assets/logo-mark.svg";
import logoWordmarkUrl from "@inventory/assets/logo-wordmark.png";

import React from "react";

import { Box } from "@mui/material";

/**
 * The Ingredifind logo. `variant` picks the compact mark (splash, status
 * screens) or the full wordmark (app header). `height` is in px; width scales
 * with the chosen asset's aspect ratio.
 */
export const IngredifindLogo = ({
  height = 24,
  variant = "mark",
}: {
  height?: number;
  variant?: "mark" | "wordmark";
}) => (
  <Box
    component={"img"}
    src={variant === "wordmark" ? logoWordmarkUrl : logoMarkUrl}
    alt={"Ingredifind"}
    sx={{ height, width: "auto", display: "block" }}
  />
);
